<template>
	<div class="container">
		<div class="main_box">
			<div class="fixed_box" @click="goContact">Contact Us</div>
			<div class="fixed_box2" @click="goSSB">
				<img src="../../assets/img/icon_board.webp" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			//
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		goContact() {
			let that = this;
			if(that.$route.path != '/contact') {
				that.$router.push({ path: '/contact', });
			}
		},
		goSSB() {
			let that = this;
			if(that.$route.path != '/scientific-strategy-board') {
				that.$router.push({ path: '/scientific-strategy-board', });
			}
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	.fixed_box{
		position: fixed;
		right: 0;
		z-index: 2;
		top: 300px;
		background-color: #0B318F;
		padding: 20px 6px 20px 6px;
		writing-mode: vertical-lr;
		transform: rotate(180deg);
		color: #ffffff;
		font-size: 18px;
		cursor: pointer;
	}
	.fixed_box2{
		position: fixed;
		right: 0;
		z-index: 2;
		top: 460px;
		transform: rotate(0deg);
		color: #ffffff;
		font-size: 18px;
		cursor: pointer;
		img{
			width: 39.5px;
		}
	}
}
</style>